/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pda-inventory.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../../app/agatextscreens/pda/inventory/pda-inventory.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../app/shared/services/authentication.service';
const styles_PdaInventoryComponent:any[] = [i0.styles];
export const RenderType_PdaInventoryComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PdaInventoryComponent,data:{}});
export function View_PdaInventoryComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_PdaInventoryComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-pda-inventory',
      ([] as any[]),(null as any),(null as any),(null as any),View_PdaInventoryComponent_0,
      RenderType_PdaInventoryComponent)),i1.ɵdid(114688,(null as any),0,i3.PdaInventoryComponent,
      [i4.Location,i5.AuthenticationService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PdaInventoryComponentNgFactory:i1.ComponentFactory<i3.PdaInventoryComponent> = i1.ɵccf('app-pda-inventory',
    i3.PdaInventoryComponent,View_PdaInventoryComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9pbnZlbnRvcnkvcGRhLWludmVudG9yeS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9pbnZlbnRvcnkvcGRhLWludmVudG9yeS5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL3NyYy9hcHAvYWdhdGV4dHNjcmVlbnMvcGRhL2ludmVudG9yeS9wZGEtaW52ZW50b3J5LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9pbnZlbnRvcnkvcGRhLWludmVudG9yeS5jb21wb25lbnQudHMuUGRhSW52ZW50b3J5Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxyXG4iLCI8YXBwLXBkYS1pbnZlbnRvcnk+PC9hcHAtcGRhLWludmVudG9yeT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NDQUFBO1VBQUEsZUFBK0I7SUFBL0I7Ozs7b0JDQUE7TUFBQTtzQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/inventory/pda-inventory.component.ngfactory.ts